import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: ':unitCode',
        loadComponent: () =>
            import(
                './research-unit-homepage/research-unit-homepage.component'
            ).then((m) => m.ResearchUnitHomepageComponent),
    },
    {
        path: '',
        loadComponent: () =>
            import('./research-units.component').then(
                (m) => m.ResearchUnitsComponent,
            ),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ResearchUnitsRoutingModule {}
